import React from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: '/icon/motor-kurye-img.svg',
    title: 'Motorlu Kurye',
    description: 'Şehir içi hızlı ve güvenli teslimatlar için profesyonel motorlu kurye ekibimizle hizmetinizdeyiz.',
    features: ['Hızlı teslimat', 'Güvenli taşıma', 'Şehir içi geniş kapsama', 'Esnek vardiya sistemi']
  },
  {
    icon: '/icon/arac-kurye-img.svg',
    title: 'Araçlı Kurye',
    description: 'İşletmenizin ihtiyacına göre büyük hacimli veya çoklu gönderileriniz için araçlı kurye çözümlerimizle yanınızdayız.',
    features: ['Büyük gönderiler', 'Ekonomik ve güvenli teslimat', 'Randevulu teslimat', 'Şehirler arası seçenek']
  },
  {
    icon: '/icon/sezonluk-kurye-img.svg',
    title: 'E-scooter Kurye',
    description: 'Yakın mesafe teslimatlarınız için çevreci ve pratik e-scooter kurye hizmetimizle fark yaratın.',
    features: ['Çevre dostu', 'Hızlı ve ekonomik', 'Küçük gönderiler', 'Şehir içi teslimat']
  },
  {
    icon: '/icon/hizli-teslimat-img.svg',
    title: 'Hızlı Teslimat',
    description: 'Hızlı teslimat süreçlerimiz, müşteri memnuniyetini en üst seviyeye çıkarır ve restoranınızın verimliliğini artırır.',
    features: ['Gelişmiş verimlilik', 'Teslimat bilgilendirme', 'Optimizasyonlu rotalar', 'Hızlandırılmış rotalar']
  },
  {
    icon: '/icon/raporlama-img.svg',
    title: 'Raporlama',
    description: 'Detaylandırılmış verimlilik raporlarıyla işletmenize özel iyileştirme çözümleri sunuyoruz.',
    features: ['Anlık teslimat takibi', 'Aktif konum takibi', 'Verimlilik raporları', 'Özel ihtiyaç raporları']
  },
  {
    icon: '/icon/entegre-sistem-img.svg',
    title: 'Esnek Çalışma',
    description: 'Kısa ve uzun vadeli projeler için esnek çalışma çözümleri. İhtiyacınıza göre personel sağlıyoruz.',
    features: ['Geçici personel', 'Proje bazlı çalışma', 'Sezonsal ihtiyaçlar', 'Esnek sözleşmeler']
  },
];

const Hizmetler: React.FC = () => {
  return (
    <div>
      {/* Page Hero */}
      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 100%)',
        color: '#fff',
        padding: '4rem 0',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 1.5rem' }}>
          <h1 style={{
            fontSize: 'clamp(2rem, 4vw, 2.75rem)',
            fontWeight: 700,
            marginBottom: '0.75rem',
            letterSpacing: '-0.02em',
          }}>
            Hizmetlerimiz
          </h1>
          <p style={{ fontSize: '1.125rem', opacity: 0.9, lineHeight: 1.6 }}>
            Her türlü kurye ihtiyacınız için profesyonel çözümlerle yanınızdayız.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section style={{ padding: '4rem 0', background: '#fff' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', padding: '0 1.5rem' }}>
          <div
            className="services-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '1rem',
            }}
          >
            {services.map((service, index) => (
              <div
                key={index}
                style={{
                  background: '#fff',
                  borderRadius: 10,
                  padding: '1rem',
                  border: '1px solid #e2e8f0',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                  textAlign: 'center',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = '#0066CC';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.borderColor = '#e2e8f0';
                }}
              >
                <div style={{
                  width: 40,
                  height: 40,
                  margin: '0 auto 0.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <img
                    src={service.icon}
                    alt={service.title}
                    style={{ width: 32, height: 32 }}
                  />
                </div>
                <h3 style={{
                  fontSize: '0.9375rem',
                  fontWeight: 600,
                  color: '#1e293b',
                  marginBottom: '0.25rem',
                }}>
                  {service.title}
                </h3>
                <p style={{
                  fontSize: '0.75rem',
                  color: '#64748b',
                  lineHeight: 1.5,
                  marginBottom: '0.5rem',
                  textAlign: 'center',
                }}>
                  {service.description}
                </p>
                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: '0 auto',
                  display: 'inline-flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                }}>
                  {service.features.map((feature, i) => (
                    <li key={i} style={{
                      fontSize: '0.75rem',
                      color: '#475569',
                      padding: '0.25rem 0',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.375rem',
                    }}>
                      <span style={{ color: '#0066CC' }}>✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 100%)',
        padding: '4rem 0',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 1.5rem' }}>
          <h2 style={{
            fontSize: '1.75rem',
            fontWeight: 700,
            color: '#fff',
            marginBottom: '0.75rem',
          }}>
            Teklif Talep Edin
          </h2>
          <p style={{
            fontSize: '1rem',
            color: 'rgba(255,255,255,0.9)',
            marginBottom: '1.5rem',
          }}>
            Özel ihtiyaçlarınıza uygun teklif almak için bizimle iletişime geçebilirsiniz.
          </p>
          <div style={{
            display: 'flex',
            gap: '0.75rem',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}>
            <Link
              to="/hizmetal"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '0.875rem 1.75rem',
                background: '#fff',
                color: '#0066CC',
                fontWeight: 600,
                fontSize: '1rem',
                borderRadius: 10,
                textDecoration: 'none',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
              }}
            >
              Teklif Alın
            </Link>
            <Link
              to="/iletisim"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '0.875rem 1.75rem',
                background: 'transparent',
                color: '#fff',
                fontWeight: 600,
                fontSize: '1rem',
                borderRadius: 10,
                border: '1.5px solid rgba(255,255,255,0.5)',
                textDecoration: 'none',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                e.currentTarget.style.borderColor = '#fff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)';
              }}
            >
              Bilgi Alın
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hizmetler;